import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealCompletionReportImage } from "~/models/DealReportImage";
import { generatePath } from "~/utils/generatePath";

type TIndex = (id: number | null) => SwrReturnType<DealCompletionReportImage[]>;
type ReturnType = {
	index: TIndex;
};

export const useDealCompletionReportImages = (): ReturnType => {
	const index: TIndex = (dealId: number | null) => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<DealCompletionReportImage[]>(
			dealId === null
				? null
				: generatePath(
						"/vendors/deals/:deal_id/deal_completion_report_images",
						{ deal_id: dealId }
					)
		);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
